import React, { ReactElement } from 'react';

interface IconInfoProps {
    color?: string;
    height?: number;
    width?: number;
}

export default function IconInfo({ color = '#000000', width = 24, height = 24, ...rest }: IconInfoProps): ReactElement {
    return (
        <svg width={width} height={height} viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g id='To-do-list' transform='translate(-387.000000, -902.000000)'>
                    <g id='to-do-list-tile-extra-info' transform='translate(371.000000, 748.000000)'>
                        <g id='ic_warning' transform='translate(14.000000, 152.000000)'>
                            <g>
                                <circle id='Oval' stroke={color} strokeWidth='2' cx='12' cy='12' r='9' />
                                <g id='Group' transform='translate(11.000000, 7.000000)' fill={color}>
                                    <rect id='Rectangle' x='0' y='3' width='2' height='7' rx='1' />
                                    <rect id='Rectangle-3' x='0' y='0' width='2' height='2' rx='1' />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
